import clsx from 'clsx';
import {ComponentProps} from 'react';

type LabelProps = ComponentProps<'label'>;
const Label = (props: LabelProps) => {
  const {children, className, ...rest} = props;
  return (
    <label
      className={clsx('block mb-2 text-xs font-semibold text-gray-900 dark:text-white', className)}
      {...rest}>
      {children}
    </label>
  );
};

export default Label;
